import React from "react"
import PropTypes from "prop-types"

import PricingChoice from './PricingChoice'

class MembershipChoices  extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      monthly: '',
      yearly: '',
      subscription: ''
    }

    this.setSubscription = this.setSubscription.bind(this)
    this.onSelectMembership = this.onSelectMembership.bind(this)
    this.cancelMembership = this.cancelMembership.bind(this)
  }



  setSubscription(subscription) {
    if(subscription != null && (subscription.plan_id === 1 || subscription.plan_id === 3 || subscription.plan_id === 5)) {
      this.setState({
        monthly: true,
        yearly: false,
        subscription: subscription
      })
    } else if (subscription != null && (subscription.plan_id === 2 || subscription.plan_id === 4 || subscription.plan_id === 6)) {
      this.setState({
        yearly: true,
        monthly: false,
        subscription: subscription
      })
    }
  }

  componentDidMount() {
    this.setSubscription(this.props.subscription)
  }

  componentDidUpdate() {
    if((this.state.subscription != this.props.subscription)) {
      this.setSubscription(this.props.subscription)
    }
  }

  onSelectMembership(plan_id) {
    if(this.props.current_user === null) {
      window.location.assign('/sign_in')
    } else {
      this.props.openCheckout(plan_id)
    }
  }



  cancelMembership() {
    if(this.props.current_user === undefined) {
      window.location.assign('/sign_in')
    } else if(this.props.subscription === null) {
      window.location.assign('/profile/home')
      return
    } else {
      this.props.cancelMembership()
    }
  }

  render() {

    return(
      <div>
      <PricingChoice size="medium" buttonText={this.state.monthly === true ? '' : "CHOOSE"} selected={this.state.monthly} onClick={() => this.onSelectMembership(5)}>
          <h3 className="pricing-card-title">PRO LEXER</h3>
          <h1 className="pricing-number">$7</h1>
          <h5 className="pricing-duration">per month</h5>
          <hr className="pink-section-break"></hr>
          <h5 className="pricing-description-text-h5">Unlimited connects</h5>
          <h5 className="pricing-description-text-h5">Custom Matching</h5>
          <h6 className="pricing-description-text-h6">(your age, gender, location)</h6>
          <h5 className="pricing-description-text-h5"><span style={{color: '#F48FB1', fontWeight: 700, fontSize: 20}}>+ </span> Beginner Plan</h5>
      </PricingChoice>
      <PricingChoice size="medium" buttonText={this.state.yearly === true ? '' : "CHOOSE"} selected={this.state.yearly} onClick={() => this.onSelectMembership(6)}>
          <h3 className="pricing-card-title">ELITE LEXER</h3>
          <h1 className="pricing-number">$39</h1>
          <h5 className="pricing-duration">per year</h5>
          <hr className="pink-section-break"></hr>
          <h5 className="pricing-description-text-h5">Save over 50%</h5>
          <h6 className="pricing-description-text-h6">($3.25/month)</h6>
          <h5 className="pricing-description-text-h5"><span style={{color: '#F48FB1', fontWeight: 700, fontSize: 20}}>+ </span> Pro Plan</h5>
      </PricingChoice>
      </div>
    )
  }
}

export default MembershipChoices
